module.exports = __webpack_public_path__ + "static/media/info.561276b4.svg";